import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const tryItems = ['Explore all 6 volumes', 'Review the matrices', 'Use the checklists', 'Test the Case Playbooks', 'Use the planning tools'];
export function Guarantee() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8 md:py-20" data-id="element-142" data-mp="1x3tp7iiejeuf">
      <div className="mx-auto max-w-2xl rounded-3xl border border-gold/40 bg-cream p-6 text-center sm:p-9" data-id="element-143" data-mp="1x2iltjsvc93u">
        <ShieldCheckIcon className="mx-auto h-12 w-12 text-gold-deep" aria-hidden="true" data-id="element-144" data-mp="14fo4gvrclpul" />
        <h2 className="mt-4 font-display text-[26px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-145" data-mp="14dthzd0fhpoe">
          7-day money-back guarantee
        </h2>
        <p className="mt-3 text-[15px] leading-relaxed text-clay" data-id="element-146" data-mp="1ed25po4pa82b">
          Try Resin Architect™ completely risk-free.
        </p>

        <ul className="mx-auto mt-6 grid max-w-sm gap-2 text-left" data-id="element-147" data-mp="qm6gmyrmpqyr">
          {tryItems.map(item => <li key={item} className="flex items-center gap-2 text-[15px] text-ink/85" data-id="element-148" data-mp="lnc0y5oykiiv">
              <CheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-149" data-mp="oxfb4c17yttm" />
              {item}
            </li>)}
        </ul>

        <p className="mt-6 text-[14px] leading-relaxed text-clay" data-id="element-150" data-mp="yp2vjszczall">
          If within 7 days you decide Resin Architect™ doesn’t provide the value you expected,
          you can request a refund within the guarantee period.
        </p>

        <CtaButton className="mt-7" label="Try Resin Architect™ risk-free" data-id="element-151" data-mp="62i4yuqpj2j3" />
      </div>
    </section>;
}